module.exports = __webpack_public_path__ + "img/img36_4.29d3c025.svg";